import { ReactNode } from 'react';

import {
  closeButtonWrapperStyle,
  containerStyle,
  contentContainerStyle,
  contentStyle,
  headerStyle,
  titleStyle
} from './styles.ts';

import CloseModalButton from '@/animations/CloseModalButton.tsx';

interface SystemModalModalProps {
  children: ReactNode;
  headerTitle: string;
  handleClose: () => void;
}

export const SystemModalContainer = ({
  children,
  headerTitle,
  handleClose
}: SystemModalModalProps) => {
  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <div style={headerStyle}>
          <span style={titleStyle}>{headerTitle}</span>
          <div style={closeButtonWrapperStyle}>
            <CloseModalButton handleClose={handleClose} />
          </div>
        </div>
        <div style={contentContainerStyle}>{children}</div>
      </div>
    </div>
  );
};